import React from "react";
import { Outlet } from "react-router-dom";
import WebHeader from "../Header/WebHeader";
import WebFooter from "./WebFooter";

const PublicLayout = () => {
  return (
    <div className="public-layout-container">
      <WebHeader />
      <Outlet />
      <WebFooter />
    </div>
  );
};

export default PublicLayout;
